import { makeStyles } from "@material-ui/core/styles";
import { color } from "../../assets/const/color";

export const useStyles = makeStyles((theme) => ({
  root: {
    "& p": {
      fontFamily: "inter !important",
    },
  },
  yes_btn: {
    padding: "15px 25px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.lightGreen} !important`,
    border: `1px solid ${color.lightGreen} !important`,
    borderRadius: "50px !important",
    margin: "0px !important",
  },
  no_btn: {
    marginLeft: "5px !important",
    padding: "15px 25px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `red !important`,
    borderRadius: "50px !important",
    margin: "0px !important",
    border: `1px solid red !important`,
  },
}));
